/**
 * 
 * This function checks if the toggle on the form is switch to No (false),
 * empty the fields before sending to database 
 * 
 * School Study toggle
 * Corhot Report toggle
 * Individual Report toggle
 * 
 * @param {object} 
 */

const CheckToggleOnStudyForm = (values: any) => {
  let data: any = {};
  if (values.school_study == false) {
      data.school_name = '';
    
      data.school_postcode = '';
    
      data.school_postcode = '';
    
      data.yr_level = '';
    
  }
  if (values.cohort_report == false) {
      data.cohort_items = [];
  }

  if (values.individual_report == false) {
      data.individual_items = [];
  }
  return {...values, ...data};
};

export default CheckToggleOnStudyForm;